/**
 * Textos (`es`) del tall «suppliers» de Qualitat i APPCC (OBR-166, homologación de proveedores). Tall propi: no es
 * toca `es.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const suppliersEs = {
  'backoffice.qualitySuppliers': {
    // Estados de homologación (lista, filtro, historial, avisos).
    statusPending: 'Pendiente',
    statusApproved: 'Homologado',
    statusNotApproved: 'No homologado',
    statusSuspended: 'Suspendido',

    // Lista de proveedores: columna y filtro.
    colHomologation: 'Homologación',
    filterHomologation: 'Homologación',
    filterAll: 'Todos los estados',
    rowHomologation: 'Homologación',

    // Sección «Homologación» del diálogo del proveedor.
    sectionTitle: 'Homologación',
    sectionHint:
      'El estado de confianza del proveedor, sus documentos y cómo ha ido cambiando. Un proveedor que no está homologado es un aviso en el pedido y en la recepción, nunca un bloqueo.',
    sectionNewHint: 'Podrás homologar al proveedor una vez lo hayas guardado.',
    sectionLoadError: 'No se ha podido cargar la homologación de este proveedor.',
    dialogTitle: 'Homologación de {{name}}',
    dialogClose: 'Cerrar',
    currentStatus: 'Estado actual',
    statusDate: 'Fecha',
    statusBy: 'Responsable',
    statusNeverChanged: 'Todavía no se ha decidido',
    statusUnknownPerson: 'Persona desconocida',
    readOnlyHint: 'El estado solo lo puede cambiar la administración o calidad.',

    // Cambiar el estado (motivo obligatorio).
    changeStatus: 'Cambia el estado',
    changeTitle: 'Cambia el estado de homologación',
    changeBody:
      'El proveedor pasa de «{{from}}» al estado que elijas. El cambio y el motivo quedan en el historial y no se pueden borrar.',
    changeTarget: 'Nuevo estado',
    changeReasonLabel: 'Motivo del cambio (obligatorio)',
    changeReasonPlaceholder: 'Por qué cambia: auditoría hecha, certificado caducado, incidencia grave…',
    changeConfirm: 'Cambia el estado',
    changeErrorForbidden: 'No tienes permiso para cambiar el estado de homologación.',
    changeErrorReason: 'Hay que escribir el motivo del cambio.',
    changeErrorNotFound: 'Este proveedor ya no existe o está dado de baja.',
    changeError: 'No se ha podido cambiar el estado. Inténtalo de nuevo.',

    // Observaciones.
    notesLabel: 'Observaciones',
    notesHint: 'Condiciones, resultado de la auditoría… Se guardan aparte del resto de la ficha, con su propio botón.',
    notesSave: 'Guarda las observaciones',
    notesSaved: 'Observaciones guardadas.',
    notesError: 'No se han podido guardar las observaciones. Inténtalo de nuevo.',

    // Historial de cambios de estado.
    historyTitle: 'Historial de cambios',
    historyEmpty: 'Todavía no se ha registrado ningún cambio de estado.',
    historyWhen: 'Cuándo',
    historyFrom: 'De',
    historyTo: 'A',
    historyReason: 'Motivo',
    historyWho: 'Quién',

    // Documentos.
    documentsTitle: 'Documentos',
    documentsHint: 'El registro sanitario (RGSEAA) y, si los tiene, certificados como IFS, BRC o ecológico.',
    documentsEmpty: 'Todavía no hay ningún documento.',
    documentsLoadError: 'No se han podido cargar los documentos.',
    documentsReadOnlyHint: 'Los documentos solo los pueden gestionar la administración, calidad y compras.',
    addDocument: 'Añade un documento',
    editDocument: 'Edita',
    deleteDocument: 'Da de baja',
    openFile: 'Abre el archivo',
    openFileFor: 'Abre el archivo de {{name}}',
    openFileError: 'No se ha podido abrir el archivo. Inténtalo de nuevo.',
    colDocName: 'Documento',
    colDocIssued: 'Emisión',
    colDocExpires: 'Caducidad',
    colDocState: 'Estado',
    colDocFile: 'Archivo',
    colDocActions: 'Acciones',
    docTypeSanitaryRegistry: 'Registro sanitario',
    docTypeCertificate: 'Certificado',
    noFile: 'Sin archivo',

    // Caducidad de un documento.
    expiryValid: 'Vigente',
    expiryExpiring: 'Caduca pronto',
    expiryExpired: 'Caducado',
    expiryNone: 'Sin caducidad',
    expiryExpiringIn_one: 'Caduca dentro de {{count}} día',
    expiryExpiringIn_other: 'Caduca dentro de {{count}} días',
    expiryExpiringToday: 'Caduca hoy',
    expiryExpiredAgo_one: 'Caducó hace {{count}} día',
    expiryExpiredAgo_other: 'Caducó hace {{count}} días',

    // Diálogo de un documento.
    docAddTitle: 'Añade un documento',
    docEditTitle: 'Edita el documento',
    docType: 'Tipo',
    docName: 'Nombre',
    docNameHint: 'Por ejemplo: RGSEAA, IFS, BRC, Ecológico.',
    docNumber: 'Número',
    docIssued: 'Fecha de emisión',
    docExpires: 'Fecha de caducidad',
    docExpiresHint: 'Déjalo en blanco si el documento no caduca.',
    docNotes: 'Notas',
    docFile: 'Archivo',
    docFileHint: 'PDF o imagen, hasta 10 MB.',
    docFileCurrent: 'Archivo guardado: {{name}}',
    docFileChosen: 'Archivo elegido: {{name}}',
    docSave: 'Guarda el documento',
    docErrorName: 'Hace falta un nombre para el documento.',
    docErrorDates: 'La fecha de caducidad no puede ser anterior a la de emisión.',
    docErrorInvalidType: 'El archivo tiene que ser un PDF o una imagen.',
    docErrorTooLarge: 'El archivo supera los 10 MB.',
    docErrorUpload: 'No se ha podido subir el archivo. Inténtalo de nuevo.',
    docErrorSave: 'No se ha podido guardar el documento. Inténtalo de nuevo.',
    docErrorNoTenant: 'No se ha podido saber a qué obrador pertenece el archivo. Vuelve a entrar.',

    // Baja de un documento (motivo obligatorio).
    docDeleteTitle: 'Da de baja el documento',
    docDeleteBody:
      'El documento deja de verse en la ficha del proveedor, pero queda en el historial. Hay que escribir el motivo.',
    docDeleteConfirm: 'Da de baja',
    docDeleteError: 'No se ha podido dar de baja el documento. Inténtalo de nuevo.',

    // Avisos que no bloquean (pedido, envío, recepción).
    warnOrderPending:
      'Este proveedor todavía no está homologado (estado pendiente). Puedes continuar, pero conviene decidir su homologación.',
    warnOrderNotApproved:
      'Este proveedor no está homologado. Puedes continuar, pero revisa si es el proveedor que quieres usar.',
    warnOrderSuspended:
      'Este proveedor está suspendido. Puedes continuar, pero revisa si es el proveedor que quieres usar.',
    warnReceptionNotApproved:
      'Este proveedor no está homologado. Puedes registrar la recepción igualmente, pero revisa la mercancía con atención.',
    warnReceptionSuspended:
      'Este proveedor está suspendido. Puedes registrar la recepción igualmente, pero revisa la mercancía con atención.',
  },
} as const;
